import { useState, useCallback, useRef } from "react";

export const useMessageFileDrop = (onFilesDrop) => {
  const [isDragging, setIsDragging] = useState(false);
  const dragCounter = useRef(0);

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    dragCounter.current++;
    if (dragCounter.current === 1) setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    dragCounter.current--;
    if (dragCounter.current === 0) setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((e) => e.preventDefault(), []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      dragCounter.current = 0;
      setIsDragging(false);
      const files = Array.from(e.dataTransfer.files || []);
      if (files.length && onFilesDrop) onFilesDrop(files);
    },
    [onFilesDrop]
  );

  return { isDragging, handleDragEnter, handleDragLeave, handleDragOver, handleDrop };
};
